import React, { useContext, useEffect, useState } from 'react'
import RecursiveContainer from '../RecursiveContainer'
import ArrowIcon from 'Components/Icons/ArrowIcon';
import LeftArrow from 'Components/Icons/LeftArrow';
import { updateCaseDetailsApi } from 'Constants';
import { Link, useNavigate } from 'react-router-dom';
import { caseTypeCommonFields } from '../CaseFormFields';
import { Context } from 'Context/Context';

function SingleFormScreen({setPage, page, caseData, setCaseData, caseId}) 
{
    const [formValues, setFormValues] = useState({});
    const {makeApiCallFunc} = useContext(Context);
    const navigate = useNavigate();
    useEffect(() => {
      setFormValues(caseData && caseData.additionalFields ? JSON.parse(caseData.additionalFields) : {})
    },[caseData]);

    const config = caseTypeCommonFields[page];
    const count = caseTypeCommonFields.length;
    const onChangeUpdate = (e, individualConfig) => {
        const {name, type} = individualConfig;
        const value = type === "date" ? e : (type === "fileUpload" ? e.currentTarget.files : e?.target?.value);
        setFormValues((prev) => {
            const newVal = {...prev}
            newVal[name] = value;
            return newVal;
          });   
      } 
      const updateCaseInformation = (formValues) => {
        const postData = {
          "additionalFields" : JSON.stringify(formValues)
        }
        
        makeApiCallFunc(
          updateCaseDetailsApi+"/"+caseId,
          postData,
          successCallback,
          (data) => console.log(data),
        )
      }
      const successCallback = (data) => {
        setCaseData(data);
        setPage(page+1);
      }
    const saveAndProceed = () => {
        window.scrollTo(0,0);
        console.log(formValues)
        updateCaseInformation(formValues);
    }
    const additionalInfoSubmit = () => {
      saveAndProceed();
      navigate("/client/caseDetails/" + caseId);
    }
  return (
    <div className='w-full font-plexsans'>
        <div className='w-full bg-ivory border border-[rgba(20,33,61,.1)] rounded-2xl shadow-[0_2px_12px_rgba(20,33,61,.06)] p-5 lg:p-8 mb-6'>
            <div className='font-spectral text-navy text-[19px] lg:text-[21px] font-semibold text-center mb-7'>{config?.title}</div>
            <div className='flex flex-col gap-6'>
            {config?.fields?.map((field, idx) =>
            <RecursiveContainer
            key={field?.name || idx}
            onBlurValidate={()=>{}}
            field={field}
            formValues={formValues}
            onChangeUpdate={onChangeUpdate}/>)}
            </div>
        </div>
        <div className='w-full flex items-center justify-between' >
          { page === 0 ?
          <Link to={"/client/caseDetails/" + caseId}
          className='flex items-center justify-center w-11 h-11 rounded-lg border-[1.5px] border-[rgba(20,33,61,.18)] text-navy hover:border-tan transition-colors mr-2'>
            <LeftArrow/>
          </Link>
          :
            <div
                onClick = {
                    (e) => {
                window.scrollTo(0,0)
                setPage(page-1)}}
                className='flex items-center justify-center w-11 h-11 rounded-lg border-[1.5px] border-[rgba(20,33,61,.18)] text-navy cursor-pointer hover:border-tan transition-colors mr-2'>
                <LeftArrow/>
            </div>
            }
            {
                parseInt(page) + 1 === count ?
                 <div className='bg-tan text-white px-5 py-3 flex items-center justify-center gap-2 rounded-lg font-semibold text-[14px] cursor-pointer hover:bg-tanDark transition-colors'
                 onClick={additionalInfoSubmit}
                 >
                    Submit and publish
                 </div>
                :
                <div className='bg-tan text-white px-5 py-3 flex items-center justify-center gap-2 rounded-lg font-semibold text-[14px] cursor-pointer hover:bg-tanDark transition-colors'
                onClick = {saveAndProceed}
                >
                  Submit
                  <ArrowIcon/>
              </div>
              }



        </div>
    </div>
  )
}

export default SingleFormScreen